import React, {FunctionComponent} from "react";
import Steps from "../../layout/Steps";
import Schedule from "../Schedule";
import MembersScreen from "../MembersScreen";
import MembersCheckout from "../MembersCheckout";
import Final from "../Final";
import {
    calculateDiscount,
} from "../../../lib/utils/helpers";
import './style.scss';
import {
    ISlot,
    TEventData, IBase,
} from "../../../lib/utils/types";
import ProductContainer from "../../common/ProductContainer";
import WrappedCounter from "./WrappedCounter";
import useSportContainer from "./hooks/useSportContainer";
import PeopleForms from "../PeopleForms";
import MemberCheckboxes from "../MembersScreen/MemberCheckboxes";
import i18next from "i18next";
import {useInjection} from "brandi-react";
import {GlobalSettingsModelStoreToken} from "../../../entities/globalConfig/model";
import { useBookingLimit } from "./hooks/useBookingLimit";
import {useHandleClientParameters} from "../../../lib/utils/hooks/useHandleClientParameters"
import {observer} from "mobx-react-lite";


const SportContainer: FunctionComponent<{page: string}> = ({page}) => {
    const {bookingCardProps, step, setStep, resetData, selectedSlot, currencies, eventData,
        selectedEvent, toStepTwo, peopleAmount, setPeopleAmount, basesList, handleTrainingData, setSelectedEvent,
        setSelectedSlot, event, url, orderId, order, isDataEntered, promocodeApplied, setBases, bases, setEventData,
        toStepThree, payingUser, setPayingUser, peopleData, isSubscriptionPay, subscriptionData, setIsSubscriptionPay,
        setPromocodeApplied, setCertificateApplied, promoAndCertDiscount, coachlessDiscount,
        fullBookDiscount, setOrder} = useSportContainer({page})
    const {t} = i18next;
    const globalSettings = useInjection(GlobalSettingsModelStoreToken);
    const isInsured = globalSettings.config['insurance_available']
                                        && globalSettings.config['insurance_available_sport']
                                        && bases?.[0]?.insurance
                                        && selectedEvent?.insurance
                                        && selectedSlot?.insurance

    const {isBookingLimitVisible, isExactly20, isRussia, 
        shouldShowCorporateWarning, isNotExactly20} = useBookingLimit({selectedEvent, selectedSlot, peopleAmount})

    useHandleClientParameters(payingUser?.id)

    return <ProductContainer productType="sport" bookingCardProps={bookingCardProps}>
            <Steps step={step} handleStepClick={(step) => setStep(step)} resetData={resetData} />

            <WrappedCounter
                    step={step}
                    selectedSlot={selectedSlot}
                    currencies={currencies}
                    eventData={eventData}
                    selectedEvent={selectedEvent}
                    event={event} />
            {step < 2 && (
                <>  
                    {(isBookingLimitVisible && isExactly20 && !isRussia) && 
                    <div className="booking-limit-warning">
                        {t('sport.schedule.selectors.secondBookingLimitWarning')}<a href={`mailto:${t('sport.schedule.selectors.BookingLimitEmail')}`}>
                        {t('sport.schedule.selectors.BookingLimitEmail')}</a> {t('sport.schedule.selectors.orCall')}
                        <a href={`tel:${t('sport.schedule.selectors.BookingLimitNumber')}`}>{t('sport.schedule.selectors.BookingLimitNumber')}</a>
                        {t('sport.schedule.selectors.makeItHappen')}
                    </div> 
                    }
                    {(shouldShowCorporateWarning && isRussia) &&
                    <div className="booking-limit-warning">
                        {bases?.[0]?.corporate_offer_message} 
                        <div>{t('sport.schedule.selectors.tel')}<a href={`tel:+${bases?.[0]?.corporate_offer_phone}`}>+{bases?.[0]?.corporate_offer_phone}</a></div>
                        <div>{t('sport.schedule.selectors.email')}<a href={`mailto:${bases?.[0]?.corporate_offer_email}`}> {bases?.[0]?.corporate_offer_email}</a></div>
                    </div>
                    }
                    {(isNotExactly20 && !isRussia) && 
                    <div className="booking-limit-warning" >
                        {t('sport.schedule.selectors.firstBookingLimitWarning')}
                        <a href={`mailto:${t('sport.schedule.selectors.BookingLimitEmail')}`}>{t('sport.schedule.selectors.BookingLimitEmail')}</a> {t('sport.schedule.selectors.orCall')} <a href={`tel:${t('sport.schedule.selectors.BookingLimitNumber')}`}>{t('sport.schedule.selectors.BookingLimitNumber') as string}</a>
                        {t('sport.schedule.selectors.makeItHappen')}
                    </div>
                    }
                    
                    <Schedule
                        // @ts-ignore
                        globalEvent={selectedEvent}
                        onSubmit={toStepTwo}
                        peopleAmount={peopleAmount}
                        basesList={basesList}
                        sendData={(data:TEventData) => handleTrainingData(data)}
                        setPeopleAmount={setPeopleAmount}
                        setGlobalEvent={(event:TEventData) => setSelectedEvent(() => event)}
                        setSlot={(slot:ISlot) => setSelectedSlot(() => slot)}
                        eventURL={event}
                        slotURL={url}
                        orderId={orderId}
                        order={order}
                        isDataEntered={isDataEntered}
                        eventData={eventData}
                        promocodeApplied={promocodeApplied}
                        setFetchedBases={(bases:[IBase]) => setBases(bases)}
                        fetchedBases={bases}
                        currencies={currencies}
                        setEventData={setEventData}
                        page={page}
                    />
                </>
            )}

            {step === 2 && (
                <MembersScreen
                    finalize={(newData, orderId) => toStepThree(newData, orderId)}
                    order={order}
                    eventData={eventData}
                    step={step}
                    payingUser={payingUser}
                    setPayingUser={setPayingUser}
                    renderPeopleForms={({form, payingUser}: any) => <PeopleForms
                            form={form}
                            isEmailEditable={!payingUser?.email}
                            isLastnameEditable={!payingUser?.last_name || payingUser?.is_insurance}
                            isFirstnameEditable={!payingUser?.first_name || payingUser?.is_insurance}
                            tg_options={eventData?.slot?.tg_options || eventData?.slot?.event_id?.tg_options}
                            confirmParticipantData={eventData?.slot?.confirm_participant_data}
                            briefDataEntry={eventData?.slot?.brief_data_entry}
                            
                    />}
                    renderCheckboxes={({isInsuredBefore, dataContainer, peopleAmount, register, errors, values}: any) => <MemberCheckboxes
                            isInsuredBefore={isInsured && isInsuredBefore}
                            dataContainer={dataContainer}
                            register={register}
                            errors={errors}
                            peopleAmount={peopleAmount}
                            values={values}
                    />}
                />
            )}
            {step === 3 && (
              <MembersCheckout
                  order={order}
                  inputMembersData={peopleData}
                  eventData={eventData}
                  step={step}
                  isSubscriptionPay={isSubscriptionPay}
                  subscriptionData={subscriptionData}
                  setIsSubscriptionPay={setIsSubscriptionPay}
                  payingUser={payingUser}
                  setPromocodeApplied={setPromocodeApplied}
                  setCertificateApplied={setCertificateApplied}
                  promoAndCertDiscount={promoAndCertDiscount}
                  additionalDiscount={calculateDiscount(coachlessDiscount, fullBookDiscount,
                          selectedSlot?.price_value || order?.slot?.price_value, peopleAmount,
                          eventData?.boat?.places || order?.boat?.places)}
                  setOrder={setOrder}
              />
            )}
            {step === 5 && (
                <Final payingUser={payingUser} orderId={orderId} order={order} setOrder={setOrder} onNewBookingClick={() => {
                    resetData()
                    setStep(1)
                }} />
            )}
        </ProductContainer>
};

export default observer(SportContainer);
